<form [formGroup]='form' class='location-info'>
    <div class="field-input address1">
        <label>{{ 'service.addressLine' | translate}}1<span style="color: red">*</span></label>
    <mat-form-field appearance="outline" class="address1">
        <input matInput formControlName='addressLine1' [placeholder]="'service.pleaseEnterYourAddress' | translate" required>
        <mat-error *ngIf="form.controls.addressLine1?.invalid">
            {{ 'service.pleaseEnterYourAddress' | translate}}1
        </mat-error>
    </mat-form-field>
    </div>

    <div class="field-input address2">
        <label >{{ 'service.addressLine' | translate}}2</label>
    <mat-form-field appearance="outline" class="address2">
        <input matInput formControlName='addressLine2' [placeholder]="'service.pleaseEnterYourAddress' | translate">
    </mat-form-field>
    </div>

    <div class="field-input state">
        <label >{{ 'service.state' | translate}}<span style="color:red">*</span></label>
    <mat-form-field appearance="outline" class="state">
        <mat-select formControlName='state' required [disabled]="!form?.value?.isZipValid && (!isZipValid)">
            <mat-option [value]='option' *ngFor="let option of formStates" (click)="selectedOption(form, option,'state') "
            (keydown)="onEnter(form, $event,'state')">
                {{ option }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.state?.invalid">
            {{ 'service.pleaseSelectAState' | translate}}
        </mat-error>
     
    </mat-form-field>
    </div>

    <div class="field-input city">
        <label >{{ 'service.city' | translate}}<span style="color:red">*</span></label>
    <mat-form-field appearance="outline" class="city">
        <mat-select formControlName='city' required [disabled]="!form?.value?.isZipValid && (!isZipValid)">
            <mat-option [value]='option' *ngFor="let option of filteredCities" (keydown)="onEnter(form, $event,'city')"
            (click)="selectedOption(form, option,'city') ">
                {{ option }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.city?.invalid">
            {{ 'service.pleaseSelectACity' | translate}}
        </mat-error>
    </mat-form-field>
 
    </div>

    <div class="field-input zipcode">
        <label>{{ 'common.Zipcode' | translate}}<span style="color:red">*</span></label>
    <mat-form-field appearance="outline" class='pincode'>
        <input matInput formControlName='zip' placeholder="{{ 'service.enterZipCode' | translate }}" (input)="inputZipChange($event)" aspNumberOnly minlength="5" maxlength="5" required>
        <div class = "tick" *ngIf="form?.value?.isZipValid && !isCustomerAddress" [ngClass]="{'selected' : form?.value?.isZipValid}" ></div>
        <mat-error *ngIf="form.controls['zip']?.errors?.remoteRequired ">{{ 'service.pleaseEnterValidRemoteZipcode' | translate}}</mat-error>
        <mat-error *ngIf="form.controls['zip']?.errors?.required ">{{ 'service.pleaseEnterValidZipcode' | translate}}</mat-error>
    </mat-form-field>
    </div>
</form>